'use strict';

import angular from 'angular';
import {ArticuloRouteComponent} from './ver/articulo-route.component.js';
import {CrearArticuloRouteComponent} from './crear/crear-articulo.component';
import {ActualizarArticuloRouteComponent} from './actualizar/actualizar-articulo.component';
import {EditarArticuloRouteComponent} from './editar/editar-articulo.component';
const ngRoute = require('angular-route');

/*@ngInject*/
const routeArticulo = function ($routeProvider) {
    $routeProvider
        .when('/articulo/ver/:codigo', {
            template: '<articulo-route articulo="$resolve.articulo.data"></articulo-route>',
            resolve: {
                articulo: getArticuloPorCodigo
            },
            authenticate: true
        })
        .when('/articulo/crear', {
            template: '<crear-articulo-route categorias="$resolve.categorias.data.categorias"></crear-articulo-route>',
            resolve: {
                categorias: getArticuloCategorias
            },
            authenticate: true,
            administrator: true
        })
        .when('/articulo/editar/:codigo', {
            template: '<editar-articulo-route articulo="$resolve.articulo.data" categorias="$resolve.categorias.data.categorias"></editar-articulo-route>',
            resolve: {
                articulo: getArticuloPorCodigo,
                categorias: getArticuloCategorias
            },
            authenticate: true,
            administrator: true
        })
        .when('/articulo/actualizar', {
            template: '<actualizar-articulos-route></actualizar-articulos-route>',
            authenticate: true,
            administrator: true
        });
    
    function getArticuloPorCodigo($route, ArticuloService){
        return ArticuloService.getArticuloPorCodigo($route.current.params.codigo);
    }
    
    function getArticuloCategorias(ArticuloService) {
        return ArticuloService.getArticuloCategorias();
    }
};

export default angular.module('pizzutoAutopartesApp.articulo', [ngRoute])
    .component(ArticuloRouteComponent.selector, ArticuloRouteComponent)
    .component(CrearArticuloRouteComponent.selector, CrearArticuloRouteComponent)
    .component(EditarArticuloRouteComponent.selector, EditarArticuloRouteComponent)
    .component(ActualizarArticuloRouteComponent.selector, ActualizarArticuloRouteComponent)
    .config(routeArticulo)
    .name;


// WEBPACK FOOTER //
// ./client/app/articulo-route/index.js